
function setNotifications(state, fyis, incoming) {
    let not = state.fyi[fyis] || [];
    incoming = incoming.map(e => {
        return {
            'id': e.ID,
            'date': parseInt(e.D) * 1000,
            'D': e.D,
            'summary': e.MS,
            'detail': e.MD,
            'fc': e.FC,
            'read': e.R == 1,
            'show': false,
            'epoch': e.D
        }
    });
    incoming.sort((a, b) => { return b.id - a.id });
    if (!state.fyi[fyis] || (state.fyi[fyis].length === 0)) {
        Vue.set(state.fyi, fyis, incoming);
    } else {
        //-- remove duplicates while updating/merging based on id
        for(var i = 0, l = not.length; i < l; i++) {
            for(var j = 0, ll = incoming.length; j < ll; j++) {
                if(not[i].id === incoming[j].id) {
                    not.splice(i, 1, incoming[j]);
                    break;
                }
            }
        }
        Vue.set(state.fyi, fyis, not);
    }
}

export default {
    CLEAR_FYI_NOTIFICATIONS(state) {
        state.fyi.fyiNotifications = [];
    },
    CLEAR_FYI_ALERTS(state) {
        state.fyi.fyiAlerts = [];
    },
    MARK_FYI_NOTIFICATION_READ(state, n) {
        let content  = undefined;
        if (n.fc == 'UA') {
            content = state.fyi.fyiAlerts.find(alert => alert.id == n.id)
        } else {
            content = state.fyi.fyiNotifications.find(alert => alert.id == n.id)
        }
        if (content) {
            content.read = true;
        }
    },
    SET_FYI_DELIVERY_OPTIONS(state, options) {
        state.fyi.fyiDeliveryOptions = options;
    },
    SET_FYI_DISCLAIMER(state, disclaimer) {
        if (!state.fyi.fyiDisclaimers.find(e => e.FC === disclaimer.FC)) {
            state.fyi.fyiDisclaimers.push(disclaimer);
        }
    },
    SET_FYI_NOTIFICATIONS(state, notifications) {
        setNotifications(state, 'fyiNotifications', notifications);
    },
    SET_FYI_ALERTS(state, notifications) {
        setNotifications(state, 'fyiAlerts', notifications);
    },
    SET_FYI_SETTINGS(state, settings) {
        state.fyi.fyiSettings = settings;
    },
    TOGGLE_FYI_EMAIL_OPTION(state) {
        if (state.fyi.fyiDeliveryOptions.M === 1) {
            state.fyi.fyiDeliveryOptions.M = 0;
        } else {
            state.fyi.fyiDeliveryOptions.M = 1;
        }
    },
    TOGGLE_FYI_DELIVERY_OPTION(state, i) {
        let option = state.fyi.fyiDeliveryOptions.E[i];
        if (option.A === 1) {
            option.A = 0;
        } else {
            option.A = 1;
        }
    },
    TOGGLE_FYI_SUBSCRIPTION(state, i) {
        let subscription = state.fyi.fyiSettings[i];
        if (subscription.A === 1) {
            subscription.A = 0;
        } else {
            subscription.A = 1;
        }
    },
    SET_COUNTRY_CODES(state, cc) {
        state.countryCodes = cc;
    },
    SET_FEEDBACK_DATA(state, fbd) {
        state.feedbackData = fbd;
    },
    SET_UNREAD_FYI_NUM(state, val) {
        state.fyiUnreadNum = val;
    },
    MARK_FYI_READ(state, amnt) {
        if (state.fyiUnreadNum <= 0) {
            console.error(`Failed to decrement fyi count by ${amnt}. Count is already <= 0: ${state.fyiUnreadNum}`)
        } else {
            state.fyiUnreadNum -= amnt;
        }
    },
    SET_UNSAVED_PRICE_ALERTS(state, val) {
        state.unsavedPriceAlerts = val;
    }
};
